import { AloftPrice } from '@aloft/toolkit-shared';
import { Td, Tr } from '@aloft/toolkit-sui';

import { useAppSelector } from '../../redux/hooks.ts';
import { RootState } from '../../redux/types.ts';
import { Typography } from '../../summary/components/Typography.tsx';
import { getCostString } from './utils/getCostString.ts';

export const CostApproachTableRollupRow = ({
  label,
  selector,
}: {
  label: string;
  selector: (state: RootState) => AloftPrice | undefined;
}) => {
  const value = useAppSelector(selector);

  return (
    <Tr>
      <Td>
        <Typography variant="h4">{label}</Typography>
      </Td>
      <Td className="cost-approach-table-align-right" colSpan={8}>
        <Typography variant="h4">{getCostString(value) ?? ''}</Typography>
      </Td>
    </Tr>
  );
};
